<ViewportWrapper class="main-container">
	<template v-if="!isDev">
		<div
			v-show="isVisibleRoute"
			v-html="currentTagOrComponentName"
			:style="computedContainerStyles"
			:key="routeParams"
		/>
	</template>
	<component v-else :is="currentTagOrComponentName" />
	<UX1AddRemove
		v-for="notification of notifications"
		:id="notification.id"
		:key="notification.id"
		@update="updateNotification"
	/>
</ViewportWrapper>
